export default __webpack_public_path__ + "static/media/icon-live.7e7c6cab.svg";